import React from "react";
import { Brain, Twitter, Linkedin, Github } from "lucide-react";

const cols = [
  {
    title: "Product",
    links: [
      "Agents",
      "Workflows",
      "Knowledge Base",
      "Tools",
      "Interactions",
      "Analytics",
    ],
  },
  {
    title: "Solutions",
    links: ["Support", "Sales", "Success", "E-commerce", "Fintech", "Travel"],
  },
  {
    title: "Resources",
    links: ["Docs", "API reference", "Changelog", "Playbooks", "Blog", "Status"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Customers", "Security", "Contact", "Press"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="landing-footer"
      className="relative border-t border-white/5 bg-[#07070c] pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-[1.3fr_repeat(4,1fr)] gap-10 md:gap-8 pb-14 border-b border-white/5">
          {/* Brand */}
          <div>
            <a href="#" className="flex items-center gap-2.5 mb-6">
              <div className="w-8 h-8 rounded-lg bg-[#7C5CFF] flex items-center justify-center shadow-[0_0_20px_rgba(124,92,255,0.5)]">
                <Brain className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="text-[15px] font-semibold">AI-CRM</span>
            </a>
            <p className="text-white/50 text-[13.5px] leading-relaxed max-w-xs">
              The Agentic AI-native Customer Interaction Platform. Every
              conversation, every channel, one customer record.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Twitter, Linkedin, Github].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center text-white/60 hover:text-white hover:border-white/20 transition-colors"
                  aria-label="social"
                >
                  <I className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/40 mb-4">
                {col.title}
              </div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                      className="text-[14px] text-white/65 hover:text-white transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-[12px] text-white/40">
          <div>© {new Date().getFullYear()} AI CRM Labs. All rights reserved.</div>
          <div className="flex items-center gap-6 font-mono tracking-wider uppercase text-[11px]">
            <a href="#" className="hover:text-white">
              Privacy
            </a>
            <a href="#" className="hover:text-white">
              Terms
            </a>
            <a href="#" className="hover:text-white">
              DPA
            </a>
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#3DDFB3] soft-pulse" />
              All systems operational
            </span>
          </div>
        </div>
      </div>

      {/* Giant watermark */}
      <div
        className="pointer-events-none absolute -bottom-20 left-1/2 -translate-x-1/2 font-serif text-[clamp(160px,25vw,380px)] leading-none tracking-tight text-white/[0.02] whitespace-nowrap select-none"
        aria-hidden="true"
      >
        angoor.ai
      </div>
    </footer>
  );
}
